import type { PolarConfig, PolarSide } from "../../lib/types";

type Props = {
  value: PolarConfig;
  onChange: (next: PolarConfig) => void;
  locked?: boolean;
};

export const DEFAULT_POLAR_CONFIG: PolarConfig = {
  side_a: { key: "side_a", label: "" },
  side_b: { key: "side_b", label: "" },
  why_prompt: "Warum?",
  why_required: false,
};

function SideEditor({
  label, value, onChange, lockKey,
}: { label: string; value: PolarSide; onChange: (s: PolarSide) => void; lockKey: boolean }) {
  return (
    <div className="flex flex-col gap-2 rounded-xl border border-rc-ink/10 p-3">
      <div className="text-xs uppercase tracking-wide text-rc-ink/60">{label}</div>
      <input
        value={value.label}
        onChange={(e) => onChange({ ...value, label: e.target.value })}
        placeholder="Label"
        className="rounded-lg border border-rc-ink/10 bg-rc-paper p-2 text-rc-ink focus:outline-none focus:ring-2 focus:ring-rc-berry"
      />
      <input
        value={value.description ?? ""}
        onChange={(e) => onChange({ ...value, description: e.target.value || undefined })}
        placeholder="Kurze Beschreibung (optional, max 80 Z.)"
        maxLength={80}
        className="rounded-lg border border-rc-ink/10 bg-rc-paper p-2 text-rc-ink focus:outline-none focus:ring-2 focus:ring-rc-berry"
      />
      <input
        value={value.key}
        onChange={(e) => onChange({ ...value, key: e.target.value })}
        disabled={lockKey}
        className="rounded-lg border border-rc-ink/10 bg-rc-paper p-2 font-mono text-xs text-rc-ink/70 focus:outline-none focus:ring-2 focus:ring-rc-berry disabled:opacity-50"
      />
    </div>
  );
}

export function PolarConfigForm({ value, onChange, locked }: Props) {
  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <SideEditor
          label="Seite A"
          value={value.side_a}
          onChange={(s) => onChange({ ...value, side_a: s })}
          lockKey={locked === true}
        />
        <SideEditor
          label="Seite B"
          value={value.side_b}
          onChange={(s) => onChange({ ...value, side_b: s })}
          lockKey={locked === true}
        />
      </div>
      <label className="flex flex-col gap-1">
        <span className="text-sm text-rc-ink/80">Begründungs-Frage</span>
        <input
          value={value.why_prompt}
          onChange={(e) => onChange({ ...value, why_prompt: e.target.value })}
          className="rounded-lg border border-rc-ink/10 bg-rc-paper p-2 text-rc-ink focus:outline-none focus:ring-2 focus:ring-rc-berry"
        />
      </label>
      <label className="flex items-center gap-2 text-sm text-rc-ink/80">
        <input
          type="checkbox"
          checked={value.why_required}
          onChange={(e) => onChange({ ...value, why_required: e.target.checked })}
        />
        Begründung verpflichtend
      </label>
      {locked && (
        <p className="text-xs text-rc-ink/60">
          Diese Frage hat bereits Antworten – Seiten-Schlüssel sind gesperrt.
        </p>
      )}
    </div>
  );
}
